import React from "react";
import {
  VStack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Select,
  Textarea,
  Button,
  Box,
  useToast,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useCategories, useCategoryTypes } from "../hooks/useCategories";
import { getCounties } from "../utils/getCounties";
import { SUPPLIER_URL } from "../api/urls";
import { useMutation } from "react-query";
import { useAxios } from "../hooks/useAxios";
import { useHistory } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import

const Register = () => {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const { data: categories } = useCategories();
  const { data: categorytypes } = useCategoryTypes();
  const selectedCategoryId = watch("organisation_category_id");
  const selectedCategoryTypeId = watch("organisation_category_type_id");

  const selectedTypeObj = categorytypes?.find(
    (t) => t.id == selectedCategoryTypeId,
  );

  const axios = useAxios();
  const toast = useToast();
  const handleAddOutlet = async (data) => {
    return axios.post(SUPPLIER_URL, data);
  };
  const { mutate, isLoading } = useMutation(handleAddOutlet, {
    onSuccess: (response) => {
      toast({ title: "Registration successful", status: "success" });
      reset();
      history.push({
        pathname: "/home",
        state: response?.data?.returned_resultset,
      });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "Something went wrong";
      toast({
        title: message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });

  const onSubmit = (data) => {
    const payload = {
      ...data,
      organisation_type: "supplier",
      organisation_category_id: data.organisation_category_id,
      organisation_category_type_id: data.organisation_category_type_id,
      contact_gender: data.contact_gender,
      country: data.country,
      location: data.location,
      bmu_name: data.bmu_name,
      contact_national_id: data.contact_national_id,
    };

    confirmAlert({
      title: "Confirm Supplier's Details",
      message: "Verify the details below before submitting.",
      buttons: [
        { label: "Confirm", onClick: () => mutate(payload) },
        { label: "Cancel" },
      ],
      childrenElement: () => (
        <Box mt={4}>
          <List spacing={3}>
            <ListItem>
              <Text as="span" fontWeight="bold">
                Supplier:
              </Text>{" "}
              {data.name}
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold">
                Owner's name:
              </Text>{" "}
              {data.contact_names}
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold">
                Phone:
              </Text>{" "}
              {data.contact_phonenumber}
            </ListItem>
            <ListItem>
              {" "}
              <Text as="span" fontWeight="bold">
                Gender:
              </Text>{" "}
              {data.contact_gender}
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold">
                Location:
              </Text>{" "}
              {data.organisation_category_id}
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold">
                Location:
              </Text>{" "}
              {data.location}, {data.country}
            </ListItem>
          </List>
        </Box>
      ),
    });
  };

  return (
    <Box width="100%" display="flex" justifyContent="center" py="2rem">
      <form style={{ width: "80%" }} onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={6} align="stretch">
          <FormControl isInvalid={errors?.name}>
            <FormLabel>Supplier's Name</FormLabel>
            <Input
              focusBorderColor="brand.800"
              placeholder="Enter name"
              {...register("name", { required: "Name is required" })}
            />
            <FormErrorMessage>{errors?.name?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.contact_names}>
            <FormLabel>Owner's Name</FormLabel>
            <Input
              focusBorderColor="brand.800"
              placeholder="Enter owner's name"
              {...register("contact_names", {
                required: "Owner's name is required",
              })}
            />
            <FormErrorMessage>
              {errors?.contact_names?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.contact_phonenumber}>
            <FormLabel>Phone Number</FormLabel>
            <Input
              focusBorderColor="brand.800"
              placeholder="07..."
              {...register("contact_phonenumber", {
                required: "Phone is required",
              })}
            />
            <FormErrorMessage>
              {errors?.contact_phonenumber?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.contact_phonenumber}>
            <FormLabel>Validation Document</FormLabel>
            <Input
              focusBorderColor="brand.800"
              placeholder="07..."
              {...register("contact_national_id", {
                required: "Validation ID is required",
              })}
            />
            <FormErrorMessage>
              {errors?.contact_phonenumber?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.contact_gender}>
            <FormLabel>Gender</FormLabel>
            <Select
              placeholder="Select gender"
              focusBorderColor="brand.800"
              {...register("contact_gender", {
                required: "Gender is required",
              })}
            >
              <option value="M">Male</option>
              <option value="F">Female</option>
            </Select>
            <FormErrorMessage>
              {errors?.contact_gender?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.organisation_category_id}>
            <FormLabel>Category</FormLabel>
            <Select
              placeholder="Select category"
              focusBorderColor="brand.800"
              {...register("organisation_category_id", {
                required: "Category is required",
              })}
            >
              {categories
                ?.filter((cat) => cat.organisation_type === "supplier")
                .map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </Select>
            <FormErrorMessage>
              {errors?.organisation_category_id?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.organisation_category_type_id}>
            <FormLabel>Category Type</FormLabel>
            <Select
              placeholder="Select category type"
              focusBorderColor="brand.800"
              {...register("organisation_category_type_id", {
                required: "Category type is required",
              })}
            >
              {categorytypes
                ?.filter(
                  (cat) => selectedCategoryId == cat?.organisation_category_id,
                )
                .map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </Select>
            <FormErrorMessage>
              {errors?.organisation_category_type_id?.message}
            </FormErrorMessage>
          </FormControl>

          {selectedTypeObj?.name === "Farmer" ? null : (
            <FormControl>
              <FormLabel>BMU Name</FormLabel>
              <Input focusBorderColor="brand.800" {...register("bmu_name")} />
            </FormControl>
          )}

          <FormControl isInvalid={errors?.country}>
            <FormLabel>Country</FormLabel>
            <Select
              placeholder="Select country"
              focusBorderColor="brand.800"
              {...register("country", { required: "Country is required" })}
            >
              <option value="kenya">Kenya</option>
              <option value="uganda">Uganda</option>
              <option value="tanzania">Tanzania</option>
            </Select>
            <FormErrorMessage>{errors?.country?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors?.location}>
            <FormLabel>Location</FormLabel>
            <Select
              placeholder="Select county"
              focusBorderColor="brand.800"
              {...register("location", { required: "Location is required" })}
            >
              {getCounties().map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors?.location?.message}</FormErrorMessage>
          </FormControl>

          <FormControl>
            <FormLabel>Description</FormLabel>
            <Textarea
              focusBorderColor="brand.800"
              placeholder="Any additional notes..."
              {...register("notes")}
            />
          </FormControl>

          <Button
            mt={4}
            colorScheme="teal"
            bg="brand.900"
            isLoading={isLoading}
            type="submit"
            width="full"
          >
            Save
          </Button>
        </VStack>
      </form>
    </Box>
  );
};
export default Register;
